// Self-advertising promo cards (Rightmove-style). Each entry promotes one of
// Safaqat 24's own features. See src/config/promoContent.ts.
// Nested under a top-level `promo` key to match the namespace convention used
// by the other local resource files (favorites, property, …).
const promo = {
  promo: {
    // "Do more with a Safaqat 24 account" — shown to logged-out visitors.
    createAccount: {
      title: 'Do more with Safaqat 24',
      body: 'Create a free account to save your favorite homes, compare them, and pick up right where you left off.',
      cta: 'Create an account or sign in',
    },

    // Logged-in counterpart on search/property — points to favorites.
    savedSearch: {
      title: 'Keep track of your search',
      body: 'Save the homes you love to your favorites and compare them anytime.',
      cta: 'View my favorites',
    },

    // Supply-side: the equivalent of Rightmove's "how much is my home worth".
    listProperty: {
      title: 'Got a property to sell or rent?',
      body: 'List it on Safaqat 24 and reach thousands of buyers and tenants across Saudi Arabia.',
      cta: 'List your property',
    },

    // Monetization: membership + coins / boosts.
    membership: {
      title: 'Go premium with Safaqat 24',
      body: 'Boost your listings, unlock smart AI search, and stand out with a membership plan.',
      cta: 'Explore membership',
    },

    // Engagement: market indicators from registered deals (/market-tools).
    marketInsights: {
      title: 'Know the market',
      body: 'Explore registered deal prices and rents by district before you decide.',
      cta: 'Explore market insights',
    },

    // Email newsletter — not live yet (shows a "Coming soon" badge).
    newsletter: {
      title: 'Get our weekly newsletter',
      body: 'A must-have if you are thinking of moving - the latest listings and market updates, straight to your inbox.',
      cta: 'Sign up for our newsletter',
    },

    // Badge for features that are built/announced but not live yet.
    comingSoon: 'Coming soon',

    // Accessibility label on the dismiss button.
    dismiss: 'Dismiss',
  },
};

export default promo;
